import { getRequest, postRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

// Function to post tournament pool data
export const postFeaturedTournamentPoolsSummary = async (tournamentEntry, featuredPosition, remove = false) => {
  console.log('Service function called with:', { tournamentEntry, featuredPosition, remove }) // Debug log

  // Handle both tournamentKey string and tournament entry object
  const tournamentKey = typeof tournamentEntry === 'string' ? tournamentEntry : tournamentEntry?.tournamentKey

  const data = {
    tournamentKey,
    featuredPosition,
    remove,
  }

  console.log('Sending data to backend:', data) // Debug log

  try {
    const { response, logComplete } = await postRequest('featuredTournamentPoolsSummary', data)

    logger.log('postFeaturedTournamentPoolSummary response:', response) // Log the full response for debugging

    logComplete()
    return response.userTournamentEntry // Return the updated userTournamentEntry
  } catch (error) {
    logger.error('postFeaturedTournamentPool', error) // Log the error
  }
}

// Function to set banner ad for featured tournaments
export const setBannerAd = async (tournamentEntry, featuredPosition, remove = false) => {
  console.log('setBannerAd service function called with:', { tournamentEntry, featuredPosition, remove }) // Debug log

  // Handle both tournamentKey string and tournament entry object
  const tournamentKey = typeof tournamentEntry === 'string' ? tournamentEntry : tournamentEntry?.tournamentKey

  const data = {
    tournamentKey,
    featuredPosition,
    remove: false, // Never remove the featured tournament, only update banner ad
    bannerAd: !remove, // Set bannerAd flag to true when not removing
  }

  console.log('Sending banner ad data to backend:', data) // Debug log

  try {
    const { response, logComplete } = await postRequest('featuredTournamentPoolsSummary', data)

    logger.log('setBannerAd response:', response) // Log the full response for debugging

    logComplete()
    return response
  } catch (error) {
    logger.error('setBannerAd', error) // Log the error
  }
}

// Function to remove all banner ads
export const removeAllBannerAds = async () => {
  console.log('removeAllBannerAds service function called') // Debug log

  const data = {
    removeAllBannerAds: true,
  }

  console.log('Sending remove all banner ads data to backend:', data) // Debug log

  try {
    const { response, logComplete } = await postRequest('featuredTournamentPoolsSummary', data)

    logger.log('removeAllBannerAds response:', response) // Log the full response for debugging

    logComplete()
    return response
  } catch (error) {
    logger.error('removeAllBannerAds', error) // Log the error
  }
}

// Function to post tournament pool data
// Module-scoped variable to hold the promise
let featuredTournamentPoolsSummaryPromise = null

export const getFeaturedTournamentPoolsSummary = () => {
  // If a request is already in progress, return that promise.
  if (featuredTournamentPoolsSummaryPromise) {
    return featuredTournamentPoolsSummaryPromise
  }

  // Otherwise, create the promise and store it.
  featuredTournamentPoolsSummaryPromise = (async () => {
    try {
      const { response, logComplete } = await getRequest('featuredTournamentPoolsSummary', {}, true)
      logger.log('getFeaturedTournamentPoolsSummary response:', response)
      logComplete()
      return response
    } catch (error) {
      logger.error('getFeaturedTournamentPoolsSummary', error)
      // Propagate the error so that callers can handle it.
      throw error
    } finally {
      // Clear the promise regardless of success or failure.
      featuredTournamentPoolsSummaryPromise = null
    }
  })()

  return featuredTournamentPoolsSummaryPromise
}

let featuredTournamentPoolsPromise = null

export const getFeaturedTournamentPools = () => {
  // If a request is already in progress, return that promise.
  if (featuredTournamentPoolsPromise) {
    return featuredTournamentPoolsPromise
  }

  // Otherwise, create the promise and store it.
  featuredTournamentPoolsPromise = (async () => {
    try {
      const { response, logComplete } = await getRequest('featuredTournamentPools', {}, true)
      logger.log('featuredTournamentPools response:', response)
      logComplete()
      return response
    } catch (error) {
      logger.error('featuredTournamentPools', error)
      // Propagate the error so that callers can handle it.
      throw error
    } finally {
      // Clear the promise regardless of success or failure.
      featuredTournamentPoolsPromise = null
    }
  })()

  return featuredTournamentPoolsPromise
}
